module.exports = __webpack_public_path__ + "assets/85ec973efb2ca0da3bd6edca04f56a3e.png";